export default {
  computed: {
    translatedCountries() {
      return _.map(
        this.countries.filter((item) => !!item),
        (country) => {
          return {
            value: this.__(country.value),
            label: this.__(country.label),
            meta: country.meta,
            selected: country.selected,
          }
        }
      )
    },
  },
}
